/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/43fgc52/screen/54134918
 */

import React, { memo } from 'react';
import * as ProgramsList from '@components/LibraryProgramsList';
import { RecurringType } from '~/services/config';

const List = ({ data = [], role = 1, dataCy, onSelect = () => {}, onToggle = () => {} }) =>
    data.map((item, index) => {
        const { schedule_interval } = item.data;
        const schedule = schedule_interval?.name || schedule_interval;

        return (
            <ProgramsList.ClosedList
                key={`${item.id}-${index}`}
                dataCy={dataCy + index}
                role={role}
                name={item.name}
                description={RecurringType[schedule]?.label}
                type="habits"
                modules={item.data.assigned}
                published={item.published}
                onToggle={() => onToggle(item.id)}
                onChange={(e) => onSelect(e, item)}
            />
        );
    });

export default memo(List);
